import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';
import { useTranslation } from './LocalizationProvider';

const DialogView = ({
  item,
  open,
  handleClose,
  dialogTitle,
  content,
  validate,
  acceptTitle,
  cancelTitle,
  acceptDisabled,
}) => {
  const t = useTranslation();
  if (!cancelTitle) {
    cancelTitle = t('sharedCancel');
  }

  return (
    <Dialog
      open={open}
      onClose={() => { handleClose(null); }}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>
        {dialogTitle}
      </DialogTitle>
      <DialogContentText />
      <DialogContent>
        {content}
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={() => handleClose(null)}>
          {cancelTitle}
        </Button>
        {acceptTitle && (
          <Button
            disabled={acceptDisabled}
            onClick={() => {
              if (validate && !validate()) {
                // Validation failed - don't show generic error, let form fields show specific errors
              } else {
                handleClose(item);
              }
            }}
          >
            {acceptTitle}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default DialogView;
